import { styled } from '../../../core/theme/styled';

export const Badge = styled.div`
  border-radius: ${({ theme }) => theme.roundedCorners.xsmall};
  color: ${({ theme }) => theme.configuration.secondaryTextColor};
  background-color: ${({ theme }) => theme.configuration.tintedBackgroundColor};
  padding-top: ${({ theme }) => theme.sizes.xxxsmall};
  padding-bottom: ${({ theme }) => theme.sizes.xxxsmall};
  padding-left: ${({ theme }) => theme.sizes.xxsmall};
  padding-right: ${({ theme }) => theme.sizes.xxsmall};
`;
